import { render, staticRenderFns } from "./ClubCardInfo.vue?vue&type=template&id=0b9deb69&scoped=true&"
import script from "./ClubCardInfo.vue?vue&type=script&lang=js&"
export * from "./ClubCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClubCardInfo.vue?vue&type=style&index=0&id=0b9deb69&lang=scss&scoped=true&"
import style1 from "./ClubCardInfo.vue?vue&type=style&index=1&id=0b9deb69&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9deb69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9deb69')) {
      api.createRecord('0b9deb69', component.options)
    } else {
      api.reload('0b9deb69', component.options)
    }
    module.hot.accept("./ClubCardInfo.vue?vue&type=template&id=0b9deb69&scoped=true&", function () {
      api.rerender('0b9deb69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardInfo/ClubCardInfo.vue"
export default component.exports